// extracted by mini-css-extract-plugin
export default {"HomeFourth":"HomeFourth_HomeFourth__Q5lv5","horizontal":"HomeFourth_horizontal__WlyUA","jsCatcch":"HomeFourth_jsCatcch__jCyAH","content":"HomeFourth_content__M5i6D"};